import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SalesOrderLineFabricProcessing, SalesOrderLineFabricProcessingDetails } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderLineFabricProcessingService extends TmsWebBaseEditCreateService<
  SalesOrderLineFabricProcessing,
  SalesOrderLineFabricProcessingDetails
> {
  public refreshDetails = new Subject<void>();
  constructor() {
    super('SalesOrderLineFabricProcessing', $localize`Additional Processing`);
  }

  getFabricProcessingForSalesOrderLine(id: string): Observable<SalesOrderLineFabricProcessingDetails[]> {
    return this.httpService.get<SalesOrderLineFabricProcessingDetails[]>(
      `${this.apiUrl}/GetFabricProcessingForSalesOrderLine?id=${id}`,
    );
  }
}
